import { Shift } from '@/models'
import {
    APP_LOGOUT,
    SHIFTS_FAILURE,
    SHIFTS_OPEN_SUCCESS,
    SHIFTS_PLANNED_SUCCESS,
    SHIFTS_REQUEST,
} from '@/redux/actionTypes'

export interface ShiftsState {
    plannedShifts: Shift[]
    openShifts: Shift[]
    currentShift: Shift | null
    loading: boolean
    errors: unknown[]
}

export type ShiftsAction =
    | { type: typeof SHIFTS_REQUEST }
    | { type: typeof SHIFTS_PLANNED_SUCCESS, plannedShifts: Shift[] }
    | { type: typeof SHIFTS_OPEN_SUCCESS, openShifts: Shift[] }
    | { type: typeof SHIFTS_FAILURE, errors: unknown[] }
    | { type: typeof APP_LOGOUT }

const initialState: ShiftsState = {
    plannedShifts: [],
    openShifts: [],
    currentShift: null,
    loading: false,
    errors: [],
}

export const shiftsReducer = (state: ShiftsState = initialState, action: ShiftsAction): ShiftsState => {
    switch (action.type) {
        case SHIFTS_REQUEST:
            return { ...state, loading: true }
        case SHIFTS_PLANNED_SUCCESS:
            return {
                ...state, loading: false, plannedShifts: action.plannedShifts,
            }
        case SHIFTS_OPEN_SUCCESS:
            return {
                ...state, loading: false, openShifts: action.openShifts,
            }
        case SHIFTS_FAILURE:
            return {
                ...state, loading: false, errors: action.errors,
            }
        case APP_LOGOUT:
            return { ...initialState }
        default:
            return state
    }
}
